import GrtExampleButtonFc from "./grt-example-button-function";
export default GrtExampleButtonFc;
